var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HgShortTripSearch',{attrs:{"is-mobile":_vm.isMobile,"destinations":_vm.orderedDestinations,"search-url":_vm.searchUrl,"show-cooperation":_vm.showCooperation,"theme":_vm.theme},on:{"onUpdateDestinationTerm":_vm.updateDestinationTerm,"onUpdateSearchParameters":_vm.updateSearchParameters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }